module.exports = __webpack_public_path__ + "img/fi-water-side-rest-200x132.1620281b.jpg";